import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
  transform(value: Date | string): string {
    const date = new Date(value);
    const options: Intl.DateTimeFormatOptions = { 
      timeZone: 'America/New_York',
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };
    
    
    const nyDate = new Intl.DateTimeFormat('en-US', options).format(date);
    

    const parts = nyDate.replace(',', '').split(' ');
    const dayName = parts[0].toUpperCase();
    const month = parts[1].toUpperCase();
    const day = parseInt(parts[2]);
    const year = parts[3];
    
  
    const dayWithSuffix = day + (day % 10 === 1 && day !== 11 ? 'ST' : 
                              day % 10 === 2 && day !== 12 ? 'ND' : 
                              day % 10 === 3 && day !== 13 ? 'RD' : 'TH');
    
    return `${dayName}, ${month} ${dayWithSuffix} ${year}`;
  }
}